function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgRiskOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.853.522a.5.5 0 0 1 .294 0l6 1.842a.5.5 0 0 1 .353.478v5.895c0 1.061-.432 2.015-1.036 2.83-.602.814-1.395 1.516-2.167 2.085a17.473 17.473 0 0 1-3.024 1.774l-.055.024-.014.007-.005.002L8 15l-.198.46-.001-.002-.005-.001-.014-.007-.055-.024a16.946 16.946 0 0 1-.9-.445 17.475 17.475 0 0 1-2.124-1.329c-.772-.569-1.565-1.27-2.167-2.085-.604-.815-1.036-1.769-1.036-2.83V2.843a.5.5 0 0 1 .353-.479l6-1.842Zm-.05 14.937L8 15c.197.46.198.46.198.459a.502.502 0 0 1-.396 0ZM2.5 3.212v5.525c0 .78.318 1.53.84 2.235.522.706 1.23 1.34 1.957 1.876a16.489 16.489 0 0 0 2.66 1.582l.043.02.044-.02a16.489 16.489 0 0 0 2.66-1.583c.726-.535 1.434-1.17 1.957-1.875.521-.705.839-1.454.839-2.235V3.212L8 1.523 2.5 3.212Zm6.25 8.038a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-1.3-2.248-.405-4.05a.96.96 0 1 1 1.91 0l-.405 4.05a.552.552 0 0 1-1.1 0Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgRiskOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgRiskOutlinedIcon);
export default Memo;